import classOperation from '@/api/class-operation'
import Subject from '@/api/subject-core'
import Year from '@/api/academic-year'
import Term from '@/api/term-semester'
import StudyTime from '@/api/study-time'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  ac_status_id: [1, 3],
  editData: [],
  termList: [],
  teacherList: [],
  building: [],
  study_times: [],
  academic_years: ['YEAR I', 'YEAR II', 'YEAR III', 'YEAR IV'],
  academic_terms: ['SEMESTER I', 'SEMESTER II'],
  all_year: false,
  history: false,
  weekday_types: [],
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.editData = data
  },
  SET_TERM_LIST(state, data) {
    state.termList = data
  },
  SET_TEACH_LIST(state, data) {
    state.teacherList = data
  },
  SET_BUILDING_LIST(state, data) {
    state.building = data
  },
  SET_ALL_YEAR_FETCH(state, value) {
    state.all_year = value
  },
  SET_STATUS_ID(state, value) {
    state.ac_status_id = value
  },
  SET_STUDY_TIMES(state, value) {
    state.ac_st_id = value
  },
  SET_WEEKDAY_TYPE(state, value) {
    state.weekday_types = value
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true,
        filter: {
          ac_status_id: _.join(context.state.ac_status_id, ',')
        }
      },
      attrubutes
    )
    return classOperation.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return classOperation.store(data)
  },

  copyClass(context, data) {
    return classOperation.copyClass(data)
  },

  update(context, { id, data }) {
    return classOperation.update(id, data)
  },
  destroy(context, id) {
    return classOperation.destroy(id)
  },
  async find(context, id) {
    let response = await classOperation.find(id)
    context.commit('SET_EDIT_DATA', response.data)
  },
  async dataBeforeCreate(context) {
    let teachergetTerm = await classOperation.getTeacher()
    context.commit('SET_TEACH_LIST', teachergetTerm.data)

    let building = await classOperation.getBuilding()
    context.commit('SET_BUILDING_LIST', building.data)

    let weekday_type = await classOperation.getWeekdayType()
    context.commit('SET_WEEKDAY_TYPE', weekday_type.data)

    return building
  },
  async getMainAndSub(context, acps_id) {
    return await classOperation.getMainAndSub(acps_id)
  },

  async getLevel(context, acps_id) {
    return await classOperation.getLevel(acps_id)
  },
  getSubject(context, attrubutes = {}) {
    return Subject.get({
      params: {
        page: -1,
        fields: {
          academic_subjects: 'subject_id,subject_name_foreign,subject_code'
        },
        filter: {
          get_subject: attrubutes.grade_id
        },
        attrubutes
      }
    })
  },
  getYear(context, attributes = {}) {
    return Year.get({
      params: Object.assign(
        {
          fields: {
            academic_years: 'ac_year_id,ac_year,ac_status_id'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getStudyTime(context, attributes = {}) {
    return StudyTime.get({
      params: Object.assign(
        {
          fields: {
            academic_study_times:
              'ac_st_id,study_time,session,number_of_session,weekday_type_id'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getTerm(context, attributes = {}) {
    return Term.get({
      params: Object.assign(
        {
          fields: {
            academic_terms:
              'ac_term_id,term_name,ac_status_id,acps_id,ac_year_id'
          },
          filter: {
            ac_year_id: attributes.ac_year_id
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  }
}
